module.exports = __webpack_public_path__ + "static/media/get-shadow.039e05f0.png";